import React from 'react';
import RecordList from '../components/RecordList';
import SEO from '../components/SEO';
import BoardApprovalStyles from '../styles/BoardApprovalStyles';
import useForm from '../utils/useForm';
import useLatestData from '../utils/useLatestData';

export default function BASearchPage() {
  const { liveBooks } = useLatestData();
  const { values, updateValue } = useForm({
    search: '',
  });
  const regex = new RegExp(`${values.search}`, 'gi');
  const results = [];
  liveBooks?.filter((record) => {
    if (
      (values.search.length > 2 && regex.test(record.title)) ||
      (values.search.length > 2 && regex.test(record.isbn)) ||
      (values.search.length > 2 && regex.test(record.author))
    ) {
      results.push(record);
    }
  });

  return (
    <>
      <SEO title="Board Approval List" />
      <BoardApprovalStyles className="search-form">
        <fieldset>
          <legend>Search by Title or Author</legend>
          <label htmlFor="search">
            <input
              type="text"
              name="search"
              id="search"
              className="search"
              placeholder="Title or Author"
              value={values.search}
              onChange={updateValue}
            />
          </label>
        </fieldset>
        <fieldset>
          <legend>Search Results</legend>
          <RecordList records={results} />
        </fieldset>
      </BoardApprovalStyles>
    </>
  );
}
